import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom/dist";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import SplashScreen from "./components/SplashScreen/SplashScreen";
import { useState } from "react";

const SPLASH_SEEN_KEY = "stargate-splash-seen";

function hasSeenSplash() {
  try {
    return sessionStorage.getItem(SPLASH_SEEN_KEY) === "1";
  } catch {
    return false;
  }
}

function App() {
  const [showSplash, setShowSplash] = useState(() => !hasSeenSplash());

  const finishSplash = () => {
    try {
      sessionStorage.setItem(SPLASH_SEEN_KEY, "1");
    } catch {
      // Storage can be unavailable in private browsing.
    }
    setShowSplash(false);
  };

  return (
    <div className="body">
      {showSplash && <SplashScreen onComplete={finishSplash} />}
      <Router>
        <header>
          <Navbar />
        </header>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
